import { useState } from "react";
import { connect } from "react-redux";
import { Button } from "expano-components";
import { BalanceWarehouseDiff } from "components";
import { AddLocation } from "./modals";
import LineItem from "./components/LineItem";

import { ReactComponent as LocationIcon } from "icons/location.svg";

const Localizations = ({ current_user, data }) => {
  const [shown, showModal] = useState(false);
  const [type, setType] = useState(null);

  const mainWarehouseDiff = data.product_main_locations.find(
    (item) => item.warehouse?.id === 1,
  )?.stock_diff;

  const shipmentWarehouseDiff = data.product_main_locations.find(
    (item) => item.warehouse?.id === 2,
  )?.stock_diff;

  return (
    <>
      {shown && (
        <AddLocation
          type={type}
          handleClose={() => {
            showModal(false);
            setType(null);
          }}
        />
      )}
      <div className="dashboard m-b-20">
        <header className="dashboard__header dashboard__header--edit">
          <div className="icon__container">
            <LocationIcon />
          </div>
          <h2 className="dashboard__title heading">Lokalizacje główne</h2>
          <div className="df v-center gap-10">
            {current_user.can_balance_warehouse_diffs && (
              <BalanceWarehouseDiff
                productId={data.id}
                mainWarehouseDiff={mainWarehouseDiff}
                shipmentWarehouseDiff={shipmentWarehouseDiff}
              />
            )}
            <Button
              type="add"
              text="Dodaj lokalizacje"
              onClick={() => {
                showModal(true);
                setType("main");
              }}
            />
          </div>
        </header>
        <ul className="product-localizations">
          {data?.product_main_locations?.map((item) => (
            <LineItem
              key={item.id}
              {...item}
              product_id={data.id}
              type="main"
            />
          ))}
        </ul>
      </div>
    </>
  );
};

export default connect(({ current_user }) => ({ current_user }))(Localizations);
